import React from 'react';
import moment from 'moment';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TimePicker from 'rc-time-picker';
import { parseError } from '../../../services/utils';
import FormField from '../../common/form-field';
import { FormComponent, FormComponentProps } from '../index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import 'rc-time-picker/assets/index.css';
import './time.css';
import readInputCss from './read-input.module.css';

export default function Time(
  name: string,
  label: string = null
): FormComponent {
  return ({ ...rest }) => <TimeComponent name={name} label={label} {...rest} />;
}

export function TimeComponent({
  name,
  label,
  parentName,
  disabled,
  readonly,
  required,
}: FormComponentProps & {
  name: string;
  label: string;
  required?: string[];
}) {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useFormContext();
  const timeName = parentName ? `${parentName}.${name}` : name;
  const error = parseError(timeName, errors);

  const {
    field: { value, onChange },
  } = useController({ name: timeName, shouldUnregister: false });

  if (readonly) {
    return (
      <FormField
        labelFor={timeName}
        label={label ? t(label) : t(name)}
        error={error ? error.message : null}
      >
        <input
          type="text"
          name={timeName}
          className={readInputCss['readonly']}
          readOnly={true}
          value={value ? moment(value).format('HH:mm') : ''}
        />
      </FormField>
    );
  } else {
    return (
      <FormField
        labelFor={timeName}
        label={label ? t(label) : t(name)}
        required={required?.includes(timeName)}
        error={error ? error.message : null}
      >
        <div>
          <TimePicker
            name={timeName}
            showSecond={false}
            minuteStep={5}
            value={moment(value)}
            disabled={disabled}
            inputIcon={<FontAwesomeIcon icon={faClock} />}
            onChange={onChange}
          />
        </div>
      </FormField>
    );
  }
}
